import "react-quill/dist/quill.snow.css";
import PageContentEditor from "../../../../../components/PageContentEditor";
import { DataCodeEnum } from "../../../../../constants/enum";

const WhatIs = () => {
  return (
    <PageContentEditor
      dataCode={DataCodeEnum.WHAT_IS_ZODIAC}
      dataName={"What is the zodiac sign?"}
    />
  );
};

export default WhatIs;
